<template>
    <div class="menu">
        <div :class="{'active': isMenuVisible}" class="menu__toggle xl:hidden md:block relative w-6 h-5 cursor-pointer z-20" @click="MenuHandle">
            <span class="w-full h-spc8 bg-secondary absolute"></span>
        </div>
        <nav :class="{'active': isMenuVisible}" class="xl:block block md:hidden  xl:relative md:fixed left-0 top-0 xl:w-auto xl:h-auto md:w-full md:h-full z-10">
            <ul class="flex xl:items-center xl:flex-row md:items-start md:flex-col xl:p-0 md:p-5">
                <li class="xl:leading-spc1 md:leading-spc3" :class="menu.className" v-for="(menu, index) in menus" :key="index">
                    <router-link :to="menu.path" class="nav-link xl:text-size1 md:text-size14 xl:p-0 md:py-spc9 xl:leading-spc2 md:leading-spc4 block font-bold text-secondary hover:text-primary">
                        {{menu.title}}
                    </router-link>
                    <ul v-if="menu.dropdowns" class="menu-list-dropdown xl:hidden md:block">
                        <li class="block" v-for="(dropdown, i) in menu.dropdowns" :key="i">
                            <router-link :to="dropdown.path" class="inline-block text-xl font-bold py-spc9 leading-spc4">
                                {{dropdown.title}}
                            </router-link>
                        </li>
                    </ul>
                </li>
                <li class="ml-6 xl:inline-block md:hidden rp-none">
                    <Button title="Browse Themes" url="#" classname="hover:border-secondary hover:bg-secondary" />
                </li>
            </ul>
        </nav>
    </div>
</template>

<script>
    import Button from "./Button";
    export default {
        name: "Navbar",
        components: {Button},
        data() {
            return {
                menus: [
                    {
                        path: '/',
                        title: 'Home',
                        className: '',
                        dropdowns: [
                            {
                                path: '#',
                                title: 'Blog themes'
                            },
                            {
                                path: '#',
                                title: 'Portfolio themes'
                            },
                            {
                                path: '#',
                                title: 'Landing page themes'
                            },
                            {
                                path: '#',
                                title: 'Documentation themes'
                            },
                            {
                                path: '#',
                                title: 'GitHub Pages themes'
                            },
                            {
                                path: '#',
                                title: 'All Premium themes'
                            },
                            {
                                path: '#',
                                title: 'All free themes'
                            }
                        ]
                    },
                    {
                        path: '#',
                        title: 'Blog',
                        className: 'xl:ml-6 md:ml-0 '
                    },
                    {
                        path: '#',
                        title: 'Resources',
                        className: 'xl:ml-6 md:ml-0 '
                    },
                    {
                        path: '#',
                        title: 'Services',
                        className: 'xl:ml-6 md:ml-0 '
                    },
                    {
                        path: '#',
                        title: 'About',
                        className: 'xl:ml-6 md:ml-0 '
                    }
                ],
                isMenuVisible: false
            }
        },
        methods: {
            MenuHandle() {
                this.isMenuVisible = !this.isMenuVisible;
            }
        }
    }
</script>

<style scoped>

</style>